import { createSelector } from 'reselect';
import { rateQuoteSelector } from '../../selectors/rate-quote/rate-quote';

export const attorneyRequiredSelector = createSelector(rateQuoteSelector, rateQuote =>
  rateQuote.map(({ defaultTitleProvider }) => defaultTitleProvider === null).orElse(() => true)
);
